// @core/api/endpoints/workflow/validate_pipeline_yaml.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ValidatePipelineYAMLRequest,
  ValidatePipelineYAMLResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Validate pipeline YAML
 * Validates a YAML pipeline definition: schema validation, DAG acyclicity, node type existence.
 */
export async function ValidatePipelineYAML(
  data: ValidatePipelineYAMLRequest,
  options?: RequestOptions
): Promise<ValidatePipelineYAMLResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/pipelines/validate-yaml`;
  const requestOptions = options;
  return client.post<ValidatePipelineYAMLResponse>(requestPath, data, requestOptions);
}
